import api from "api";
import { useMutation } from "react-query";

const useDeleteInsurance = () => {
  return useMutation((id: number) => api("DELETE /us_insurance_profiles/{id}", [id]));
};

export default useDeleteInsurance;
